type GTMEvent = {
    event: string
    content_id: string
    button: string
    page_url: string
}

type BannderData = {
    textContent: string
    href: string
}

export const pushBannerClickView = (
    data: Record<string, unknown>
): GTMEvent => {
    const { containerID, BannderData } = data

    return {
        event: 'select_content',
        content_id: containerID as string,
        button: BannderData
            ? ((BannderData as BannderData).textContent as string)
            : '',
        page_url: BannderData
            ? ((BannderData as BannderData).href as string)
            : ''
    }
}
